export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password（admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.kybInitWarning':
    'KYB profile creation failed. Some features may be unavailable. Please try again later or contact support.',
  'pages.login.username.label': 'Username',
  'pages.login.username.placeholder': 'Please input your username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Please input your password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.submitLoading': 'Logging in...',
  'pages.login.loginWith': 'Login with :',
  'pages.login.leftTitle': 'Global payment and fund management platform for enterprises',
  'pages.login.leftSubtext': 'Connect banks and payment networks for efficient, secure fund flow',
  'pages.login.formTitle': 'Welcome back!',
  'pages.login.formSubtitle': 'Please login to access your account.',
  'pages.login.username.tooltip': 'admin / user',
  'pages.login.password.label': 'Password',
  'pages.login.password.show': 'Show password',
  'pages.login.password.hide': 'Hide password',
  'pages.login.signUp': 'Sign Up',
  'pages.login.footer': "Don't have an account?",
  'pages.login.registerAccount': 'Register Account',
  'pages.login.agreement.prefix': 'I have read and agreed',
  'pages.login.agreement.serviceAgreement': 'Service Agreement',
  'pages.login.agreement.and': 'and',
  'pages.login.agreement.privacyPolicy': 'Privacy Policy',
  'pages.login.agreement.required':
    'Please read and agree to the Service Agreement and Privacy Policy before logging in.',
  'pages.agreement.back': 'Back to Login',
  'pages.agreement.brand': 'Pan-Asia Payment',

  'pages.register.leftTitle': 'Global payment and fund management platform for enterprises',
  'pages.register.leftSubtext': 'Connect banks and payment networks for efficient, secure fund flow',
  'pages.register.formTitle': 'Create Account',
  'pages.register.formSubtitle': 'Fill in the information below to complete registration.',
  'pages.register.email.label': 'Email',
  'pages.register.email.placeholder': 'Enter your email address',
  'pages.register.email.required': 'Please enter your email!',
  'pages.register.email.invalid': 'Invalid email format!',
  'pages.register.username.label': 'Username',
  'pages.register.username.placeholder': 'Enter your username',
  'pages.register.username.required': 'Please enter your username!',
  'pages.register.password.label': 'Password',
  'pages.register.password.placeholder': 'Set password (at least 6 characters)',
  'pages.register.password.required': 'Please enter your password!',
  'pages.register.password.minLength': 'Password must be at least 6 characters!',
  'pages.register.password.show': 'Show password',
  'pages.register.password.hide': 'Hide password',
  'pages.register.confirmPassword.label': 'Confirm Password',
  'pages.register.confirmPassword.placeholder': 'Enter password again',
  'pages.register.confirmPassword.mismatch': 'Passwords do not match!',
  'pages.register.agreeTerms': 'I have read and agree to the',
  'pages.register.agreeTerms.required': 'Please agree to the terms and privacy policy!',
  'pages.register.termsLink': 'User Agreement',
  'pages.register.submit': 'Register',
  'pages.register.submitLoading': 'Registering...',
  'pages.register.success': 'Registration successful! Please log in.',
  'pages.register.failure': 'Registration failed, please try again!',
  'pages.register.footer': 'Already have an account?',
  'pages.register.signIn': 'Sign In',

  'pages.welcome.advancedComponent': 'Advanced Component',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.advancedLayout': 'Advanced Layout',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'bacth deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  'pages.global.male': 'Male',
  'pages.global.female': 'Female',
  'pages.global.requiredMessage': 'This field is required',
  'pages.monitoring.alerts.name': 'Name',
  'pages.monitoring.alerts.primaryName': 'Primary Name',
  'pages.monitoring.alerts.gender': 'Gender',
  'pages.monitoring.alerts.country': 'Country',
  'pages.monitoring.alerts.dob': 'DOB',
  'pages.monitoring.alerts.match': 'Match',
  'pages.monitoring.alerts.status': 'Status',
  'pages.monitoring.alerts.alertTime': 'Alert Time',
  'pages.monitoring.alerts.category': 'Category',
  'pages.monitoring.alerts.action': 'Action',
  'pages.monitoring.alerts.review': 'Review',
  'pages.monitoring.alerts.review.success': 'Status Updated',
  'pages.monitoring.alerts.comment': 'Comment',

  'pages.monitoring.cases.name': 'Case Name',
  'pages.monitoring.cases.alerts': 'Alerts',
  'pages.monitoring.cases.countryorterritory': 'Country/Territory',
  'pages.monitoring.cases.segment': 'Business area',
  'pages.monitoring.cases.status': 'Status',
  'pages.monitoring.cases.action': 'Action',
  'pages.monitoring.cases.download.report': 'Download Report',
  'pages.monitoring.cases.addtab': 'Add Filter View Tab',
  'pages.monitoring.cases.update': 'Update Filter View Tab',
  'pages.monitoring.cases.status.mitigated': 'mitigated',
  'pages.monitoring.cases.status.processing': 'processing',
  'pages.monitoring.cases.status.passed': 'passed',
  'pages.monitoring.cases.status.rejected': 'rejected',
  'pages.monitoring.cases.customname': 'Name',
  'pages.monitoring.cases.any': 'Any',
  'pages.monitoring.cases.view.tab.name': 'View Name',
  'pages.monitoring.cases.update.operate': 'Edit',

  'pages.monitoring.casesdetail.basic.info.title': 'Basic Info',
  'pages.monitoring.casesdetail.card.id': 'Card ID',
  'pages.monitoring.casesdetail.create.time': 'Created Time',
  'pages.monitoring.casesdetail.update.time': 'Update Time',
  'pages.monitoring.casesdetail.status': 'Status',
  'pages.monitoring.casesdetail.segment': 'Business area',

  'pages.monitoring.casesdetail.associations': 'Associations',
  'pages.monitoring.casesdetail.match': 'Match',
  'pages.monitoring.casesdetail.alert.time': 'Alert Time',
  'pages.monitoring.casesdetail.category': 'Category',
  'pages.monitoring.casesdetail.review': 'Review',
  'pages.monitoring.casesdetail.profile': 'Profile',
  'pages.monitoring.casesdetail.gender': 'Gender',
  'pages.monitoring.casesdetail.dob': 'DOB',
  'pages.monitoring.casesdetail.relationShip': 'RelationShip',
  'pages.monitoring.casesdetail.last.screening.time': 'Last Screening Time',

  'pages.monitoring.profile': 'Association Profile',
  'pages.monitoring.profile.basicInfo': 'Basic Info',
  'pages.monitoring.profile.phase': 'Phase',
  'pages.monitoring.profile.lastName': 'Last Name (Pinyin)',
  'pages.monitoring.profile.lastNameEn': 'lastNameEn',
  'pages.monitoring.profile.fullName': 'fullName',
  'pages.monitoring.profile.firstName': 'First Name (Pinyin)',
  'pages.monitoring.profile.firstNameEn': 'First Name',

  'pages.monitoring.profile.sex': 'Gender',
  'pages.monitoring.profile.nationality': 'Nationality',
  'pages.monitoring.profile.dob': 'DOB',
  'pages.monitoring.profile.occupation': 'Occupation',

  'pages.monitoring.profile.address': 'Address',
  'pages.monitoring.profile.address.country': 'Country',
  'pages.monitoring.profile.address.state': 'State / Province',
  'pages.monitoring.profile.address.city': 'City',
  'pages.monitoring.profile.address.district': 'Streets',
  'pages.monitoring.profile.address.address': 'Detail Address',
  'pages.monitoring.profile.address.postCode': 'Postcode',

  'pages.monitoring.profile.idDetail': 'Identification Details',
  'pages.monitoring.profile.idType': 'Type',
  'pages.monitoring.profile.idNumber': 'IdNumber',
  'pages.monitoring.profile.idCountry': 'Issue Country',
  'pages.monitoring.profile.idExpiryDate': 'Expiration Date',
  'pages.monitoring.profile.idIssueDate': 'Issuing Date',
  'pages.monitoring.profile.viewCertificate': 'View Certificate',

  'pages.monitoring.profile.report': 'Reports',
  'pages.monitoring.profile.report.upload': 'Upload',
  'pages.monitoring.profile.report.history': 'History',

  'pages.monitoring.profile.report.collectedTime': 'CollectedTime',
  'pages.monitoring.profile.report.relateFile': 'RelateTime',
  'pages.monitoring.profile.preview': 'PreView',

  'pages.monitoring.profile.Image.front': 'front',
  'pages.monitoring.profile.Image.back': 'back',
  'pages.monitoring.profile.Image.side': 'side',

  'pages.monitoring.cases.relate': 'Relate',
  'pages.monitoring.casesdetail.relateAlert': 'Related Alerts',
  'pages.monitoring.profile.email': 'Email',
  'pages.monitoring.profile.country': 'Country',
  'pages.monitoring.profile.state': 'State / Province',
  'pages.monitoring.profile.city': 'City',
  'pages.monitoring.profile.district': 'Streets',
  'pages.monitoring.profile.postCode': 'PostCode',
  'pages.monitoring.profile.male': 'male',
  'pages.monitoring.profile.Female': 'Female',
  'pages.monitoring.profile.female': 'female',

  'pages.monitoring.profile.edit.custom': 'Edit User Information',
  'pages.monitoring.alerts.payer.status': 'Payer Status',
  'pages.monitoring.alerts.beneficiary.status': 'Beneficiary Status',
  'pages.monitoring.alerts.idNumber': 'IdNumber',
  'pages.monitoring.alerts.payer': 'payer',
  'pages.monitoring.alerts.beneficiary': 'beneficiary',
  'pages.monitoring.alerts.customerType': 'CustomerType',

  'pages.search.advancedSearch.searchType': 'Search Type',
  'pages.search.advancedSearch.searchType.precise': 'Precise',
  'pages.search.advancedSearch.searchType.near': 'Near',
  'pages.search.advancedSearch.searchType.broad': 'Broad',
  'pages.monitoring.alerts.check.status': 'Check Status',
  'pages.monitoring.alerts.check.checked': 'Checked',
  'pages.monitoring.alerts.check.needcheck': 'Need Check',
  'pages.monitoring.alerts.screeningId': 'ScreeningId',
  'pages.monitoring.casesdetail.Reason': 'Reason',
  'pages.monitoring.casesdetail.relateRisk': 'Relate Risk',
  'pages.monitoring.casesdetail.relateRiskType': 'Risk Type',
  'pages.monitoring.casesdetail.operate': 'Operate',
  'pages.monitoring.casesdetail.relateRisk.credentials': 'Credentials Risk',
  'pages.monitoring.casesdetail.downValidation': 'Dow Jones Certification',
  'pages.monitoring.casesdetail.downValidation.passed': 'passed',
  'pages.monitoring.casesdetail.downValidation.failed': 'failed',
  'pages.monitoring.casesdetail.downValidation.pending': 'pending',
  'pages.monitoring.cases.step.passed': 'passed',
  'pages.monitoring.cases.step.failed': 'failed',
  'pages.monitoring.cases.payer': 'Cases Name',
  'pages.monitoring.cases.beneficiary': 'Beneficiary Name',
  'pages.monitoring.cases.risk.level': 'Risk Level',
  'pages.monitoring.cases.downValidation': 'Dow Jones Verification',
  'pages.monitoring.cases.bankcard.id': 'BankCard Id',
  'pages.monitoring.cases.phone': 'Phone',
  'pages.monitoring.cases.alertidandname': 'AlertId / Name',
  'pages.monitoring.cases.created.time': 'Create Time',
  'pages.monitoring.cases.update.time': 'Evaluation time',
  'pages.monitoring.cases.rejectedType': 'Rejected Type',
  'pages.monitoring.profile.Gender': 'Gender',

  'pages.monitoring.businesscases.name': 'Cases Name',
  'pages.monitoring.businesscases.accountName': 'Business AccountName',
  'pages.monitoring.businesscases.accountNumber': 'Business AccountNumber',
  'pages.monitoring.businesscases.socialCode': 'Unified Social Credit Code',

  'pages.reports.search': 'Please enter the order number.',
  'pages.reports.record.create': 'Create',
  'pages.reports.record.update': 'Update',
  'pages.reports.record.tmp.doenload': 'Download Template',
  'pages.reports.record.order.no': 'OrderNo',
  'pages.reports.record.order.amount': 'Amount',
  'pages.reports.record.order.cur': 'Currency',
  'pages.reports.record.order.payee': 'Payee',
  'pages.reports.record.order.payer': 'Payer',
  'pages.reports.record.order.date': 'Date',
  'pages.reports.record.order.status': 'Status',
  'pages.reports.record.order.purpose': 'Purpose',
  'pages.reports.record.order.step': 'Step',
  'pages.reports.record.order.describe': 'Analyse',
  'pages.reports.record.order.primaryRemark': 'Primary Remark',
  'pages.reports.record.order.reviewRemark': 'Review Remark',
  'pages.reports.record.order.remark': 'Other Remark',
  'pages.reports.record.order.fileList': 'Attachment',
  'pages.reports.record.order.operate': 'Operate',
  'pages.reports.record.order.review.pass': 'Pass',
  'pages.reports.record.order.review.reject': 'Reject',
  'pages.reports.record.order.delete': 'Delete',
  'pages.reports.record.order.upload': 'Upload File',
  'pages.reports.record.order': 'Suspicious Record',
  'pages.reports.record.input': 'Please Input',
  'pages.reports.record.select': 'Please Select',
  'pages.reports.record.success': 'Success!',
  'pages.reports.record.failed': 'failed !',
  'pages.monitoring.alerts.remark': 'Remark',
  'pages.monitoring.search.required': 'Please Input search name',
  'pages.monitoring.search.review':
    'The current browser does not support preview, and it has been downloaded automatically.',
  'pages.monitoring.search.error': 'An error occurred, please try again later.',

  xch_00723: 'Transaction Scenario',
  xch_01207: 'Salary/Family Support',
  xch_01208: 'Payroll',
  xch_01209: 'Goods',
  xch_01210: 'Services',
  xch_01211: 'Tuition',
};
